module.exports = __webpack_public_path__ + "img/06.e5f85662.png";